
import {map} from 'rxjs/operators';
import { Injectable } from "@angular/core";
import { StompRService } from "@stomp/ng2-stompjs";
import { Message } from "@stomp/stompjs";
import stompConfig, { afcs_app } from "./stompConfigProvider";
import { AuthService } from "../authentication/authentication.servicie";
import { SocketEventsEnum } from "../config";


@Injectable()
export class WebStompService {
        connectedEtim: string;
        processTimerid: any;

        constructor(private _stompService: StompRService, private authService: AuthService) {

        }

        public initStomp(IMEINumber: string) {
                this.connectedEtim = IMEINumber;
                stompConfig.headers.token = `wb_${IMEINumber}`;
                console.log("stompConfig", stompConfig);
                this._stompService.config = stompConfig;
                this._stompService.initAndConnect();
        }

        public subscribeMessageStream() {
                return this._stompService.subscribe('/user/queue/greetings').pipe(map((message: Message) => {
                        return message.body;
                }));
        }

        public subscribePingStream() {
                return this._stompService.subscribe('/topic/ping').pipe(map((message: Message) => {
                        return message;
                }));
        }


        public subscribeState() {
                return this._stompService.state;
        }

        public publish(key: SocketEventsEnum, waybillno?, deviceToken?) {
                this._stompService.publish(`${afcs_app}/webClientAck`, JSON.stringify({
                        //userToken: this.authService.token,
                        waybill: waybillno, status: key, deviceToken: deviceToken
                }));
        }

        /**
         * initiates a scheduler call for checking device's availability while sync process
         */
        initiateScheduler() {
                this.processTimerid = setInterval(() => {
                        this.checkDeviceConnectivity()
                }, 10000)
        }

        stopScheduler() {
                clearInterval(this.processTimerid);
        }

        public pong() {
                this._stompService.publish(`${afcs_app}/pong`, JSON.stringify({}));
        }

        public checkDeviceConnectivity() {
                this._stompService.publish(`${afcs_app}/activedevices`, 'a');
        }

        public shouldReconnect(value?): boolean {
                if (this.isConnected()) {
                        if (this.connectedEtim != value) {
                                this.disconnect();
                                return true;
                        } else {
                                return false;
                        }
                } else {
                        return true;
                }


        }

        public disconnect() {
                console.log("hitting disconnect");
                if (this.isConnected()) {
                        this._stompService.disconnect();
                }
        }

        public isConnected() {
                return this._stompService.connected();
        }

}
